<ng-container>
  <div class="content">
    <h3 *ngIf="data.type === 'available'">
      Are you sure you want to change the status to  {{ statusLabel }} to all Available devices?
    </h3>
    <h3 *ngIf="data.type == 'all'">
      Are you sure you want to change the status to {{ statusLabel }}?
    </h3>
    <label style="font-size: 10px" *ngIf="data.type == 'all'">
      * New Status will be applied to devices with status ‘After Use’ ,
      ‘Charging’ , ‘New’
    </label>
    <div class="button-container">
      <button [disabled]="loader" mat-stroked-button (click)="dialogRef.close()" class="cancel-btn">
        Cancel
      </button>
      <button
        [disabled]="loader"
        mat-flat-button
        (click)="changeStatus()"
        color="primary"
        class="save-btn"
      >
      {{loader ? 'Saving...' : 'Change'}}

      </button>
    </div>
  </div>
</ng-container>
